<div class="tile" [ngClass]="{'errorTile' : error}">

    <div class="tileHead">
        {{heading}}
        <div class="unit">
            {{unit}}
        </div>
    </div>

    <div class="tileBody">
        <div *ngIf="value[0] != null; else placeholdPie">
            <app-piechart [value]='value'
                          [setOptions]="options">
            </app-piechart>
        </div>
    </div>
</div>

<ng-template #placeholdPie>
    <app-placehold-piechart></app-placehold-piechart>
</ng-template>